import { Skeleton } from "@amazing-care/ui/skeleton";
import { PageSkeleton } from "@/components/page-skeleton";

/**
 * The staff layout's outline, shown while the session and profile load, so
 * signing in or refreshing settles into the real shell instead of popping it
 * in around a spinner.
 */
export function AppShellSkeleton() {
  return (
    <div className="flex min-h-svh bg-background">
      <div className="hidden w-64 shrink-0 flex-col gap-6 border-r bg-sidebar p-4 md:flex">
        <Skeleton className="h-9 w-36" />
        <Skeleton className="h-8 w-full" />
        <div className="space-y-2">
          <Skeleton className="h-3 w-24" />
          {[0, 1, 2, 3].map((slot) => (
            <Skeleton key={slot} className="h-8 w-full" />
          ))}
        </div>
        <Skeleton className="mt-auto h-12 w-full" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-14 items-center gap-2 border-b px-4">
          <Skeleton className="size-7" />
          <Skeleton className="h-4 w-32" />
          <div className="flex-1" />
          <Skeleton className="h-8 w-40 sm:w-56" />
          <Skeleton className="size-8" />
        </div>
        <div className="flex-1 px-4 py-8 sm:px-6 lg:px-8">
          <PageSkeleton />
        </div>
      </div>
    </div>
  );
}
